import * as React from "react";
import { Box, Stack, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { updateResourcesPageSelectedTab } from "../../app/slices/resourcesPageSlice";
import { FeatureFlag } from "../../featureFlags";
import { eGroupIds, eRoleIds, UserClaimsService } from "../../services/currentUserService/currentUserService";
import GlGroupsPanel from "./payrollTabs/glGroups";
import GlCodesPanel from "./payrollTabs/glCodes";
import GeneralTab from "./payrollTabs/general";
import PayRatesPanel from "./payrollTabs/payRate";
import AdminLocationsPanel from "./payrollTabs/adminLocations";
import MiscWorkPanel from "./payrollTabs/miscWork";
import PayDatesPanel from "./payrollTabs/payDates";

export type PayrollTabsProps = {
    defaultTab: string;
};

export const PayrollTabs: React.FC<PayrollTabsProps> = (props) => {
    const stateSelector = useSelector((state: any) => state.resourcesPage);

    const claimService = new UserClaimsService();
    const features = React.useContext(FeatureFlag);

    const isPayrollFeature = !!features?.["payroll-admin"]?.active;
    const isPayrollManager = claimService.IsUserInAppRoles([eRoleIds.ePayrollManager]);

    // redux state
    const dispatch = useDispatch();

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        dispatch(updateResourcesPageSelectedTab(newValue));
    };

    if (!isPayrollFeature || (!isPayrollManager && !claimService.IsUserInGroups([eGroupIds.eCCLSuperAdmin]))) {
        return (
            <Box sx={{ width: 1, height: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Stack spacing={1} sx={{ textAlign: "center" }}>
                    <Box sx={{ fontSize: "18px", fontWeight: 600 }}>Payroll Access</Box>
                    <Box sx={{ fontSize: "14px" }}>You do not have access to this feature.</Box>
                </Stack>
            </Box>
        );
    }

    return (
        <TabContext
            value={
                stateSelector.selectedTab === "-1" ? props.defaultTab : stateSelector.selectedTab
            }
        >
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleTabChange} aria-label="Session View Tabs">
                    <Tab
                        label="Reports"
                        id="payroll-reports"
                        value="1"
                        aria-controls="payroll-reports"
                        sx={{ fontSize: "14px", textTransform: "none" }}
                    />
                    <Tab
                        label="Misc. Work"
                        id="payroll-misc-work"
                        value="2"
                        aria-controls="payroll-misc-work"
                        sx={{ fontSize: "14px", textTransform: "none" }}
                    />
                    <Tab
                        label="Admin. Locations"
                        id="payroll-locations"
                        value="3"
                        aria-controls="payroll-locations"
                        sx={{ fontSize: "14px", textTransform: "none" }}
                    />
                    <Tab
                        label="GL Codes"
                        id="gl-codes"
                        value="4"
                        aria-controls="gl-codes"
                        sx={{ fontSize: "14px", textTransform: "none" }}
                    />
                    <Tab
                        label="GL Groups"
                        id="gl-groups"
                        value="5"
                        aria-controls="gl-groups"
                        sx={{ fontSize: "14px", textTransform: "none" }}
                    />
                    <Tab
                        label="Pay Dates"
                        id="pay-dates"
                        value="6"
                        aria-controls="pay-dates"
                        sx={{ fontSize: "14px", textTransform: "none" }}
                    />
                    <Tab
                        label="Pay Rates"
                        id="pay-rates"
                        value="7"
                        aria-controls="pay-rates"
                        sx={{ fontSize: "14px", textTransform: "none" }}
                    />
                </TabList>
            </Box>
            <Box sx={{ width: 1, height: 1 }}>
                <TabPanel value="1" sx={{ width: 1, height: 1 }}>
                    <Box sx={{ width: 1, height: 1, display: "flex" }}>
                        <GeneralTab />
                    </Box>
                </TabPanel>
                <TabPanel value="2" sx={{ width: 1, height: 1 }}>
                    <Box sx={{ width: 1, height: 1, display: "flex" }}>
                        <MiscWorkPanel />
                    </Box>
                </TabPanel>
                <TabPanel value="3" sx={{ width: 1, height: 1 }}>
                    <Box sx={{ width: 1, height: 1, display: "flex" }}>
                        <AdminLocationsPanel />
                    </Box>
                </TabPanel>
                <TabPanel value="4" sx={{ width: 1, height: 1 }}>
                    <Box sx={{ width: 1, height: 1, display: "flex" }}>
                        <GlCodesPanel />
                    </Box>
                </TabPanel>
                <TabPanel value="5" sx={{ width: 1, height: 1 }}>
                    <Box sx={{ width: 1, height: 1, display: "flex" }}>
                        <GlGroupsPanel />
                    </Box>
                </TabPanel>
                <TabPanel value="6" sx={{ width: 1, height: 1 }}>
                    <Box sx={{ width: 1, height: 1, display: "flex" }}>
                        <PayDatesPanel />
                    </Box>
                </TabPanel>
                <TabPanel value="7" sx={{ width: 1, height: 1 }}>
                    <Box sx={{ width: 1, height: 1, display: "flex" }}>
                        <PayRatesPanel />
                    </Box>
                </TabPanel>
            </Box>
        </TabContext>
    );
};
export default PayrollTabs;
